<template>
	<span
		v-if="disabled"
		:disabled="disabled"
		v-on="$listeners"
		class="btn"
		ref="btnElement"
	>
		<span v-if="hasSlotData && slotNeedsWrapping">
			<slot />
		</span>
		<slot v-else />
		<span
			v-for="part in parts"
			v-html="part"
		/>
	</span>
	<a
		v-else-if="isLink"
		:href="link"
		:target="target"
		v-on="$listeners"
		:disabled="disabled"
		class="btn btn--shape--h48"
		ref="btnElement"
	>
		<span v-if="hasSlotData && slotNeedsWrapping">
			<slot />
		</span>
		<slot v-else />
		<span
			v-for="part in parts"
			v-html="part"
		/>
	</a>
	<button
		v-else
		:href="link"
		v-on="$listeners"
		:disabled="disabled"
		class="btn btn--shape--h48"
		ref="btnElement"
	>
		<span v-if="hasSlotData && slotNeedsWrapping">
			<slot />
		</span>
		<slot v-else />
		<span
			v-for="part in parts"
			v-html="part"
		/>
	</button>
</template>

<script>
export default {
	name: 'ThemeBtn',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		tag: String,
		link: String,
		target: String,
		parts: Array
	},
	computed: {
		isLink() {
			return this.link && this.link.length > 0
		},
		hasSlotData() {
			return this.$slots.default
		},
		slotNeedsWrapping() {
			// Any non-empty text nodes
			let slots = this.$slots.default
			return slots && slots.length > 0 && slots.filter(slot => !slot.tag && !/^\s*$/.test(slot.text)).length
		}
	}
}
</script>

<style scoped lang="scss">
	@import "src/scss/toolkit";

	.btn[disabled] {
			pointer-events: none;
		}
</style>



// WEBPACK FOOTER //
// src/components/atoms/ThemeBtn.vue